import styled from "@emotion/styled";

interface Props {
  top?: boolean;
  bottom?: boolean;
  left?: boolean;
  right?: boolean;
}

const SafeArea = styled.div<Props>`
  padding-top: ${(props) => (props.top === true ? "env(safe-area-inset-top)" : 0)};
  padding-bottom: ${(props) => (props.bottom === true ? "env(safe-area-inset-bottom)" : 0)};
  padding-left: ${(props) => (props.left === true ? "env(safe-area-inset-left)" : 0)};
  padding-right: ${(props) => (props.right === true ? "env(safe-area-inset-right)" : 0)};
`;

export default SafeArea;
